<script>
	import { projectSettings, acceptedSupportFileUploadList } from "../../config";
	import model from "../../stores/modelStore";
	import { registerPageComplete } from "../../gtm";
	import registrationTypes from "../../config/registrationTypes"

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let pageTitle = null;
	export let disabled = false;
	export let pageName = null;
	export let lastVisitedPage = null;

	let buttons = null;

	let id = "fileUploader";
	let options = {
		url: "/api/file-upload?token=" + $model.RegistrationToken,
		acceptedFiles: acceptedSupportFileUploadList,
		dictInvalidFileType: "Only PDF and JPEG files are allowed."
	};

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	$model.documentList = $model.documentList || [];

	const handleSubmit = async (e) => {
		buttons.blockNext();

		await registerPageComplete(pageName);

		buttons.next();
		buttons.unblock();
	};
</script>

<PageSection>
	<Form {disabled} id="form-docs" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Supporting Documentation</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		{#if !disabled}
			<p>
				Please provide documentary evidence of your trading in Cochlear Limited securities. Supporting documents may include
				holding statements, buy and sell contract notes, CHESS statements or broker account statements.
			</p>

			<FormRow>
				<FormColumn>
					{#key "dzSupportDocs"}
					<DropZone
						{options}
						id="dzSupportDocs"
						message="Drop files here or click to upload for this registration"
						bind:documentList={$model.documentList}></DropZone>
					{/key}
				</FormColumn>
			</FormRow>

			{#if $model && (
				$model.RegistrationType === registrationTypes.types.SMSF.value ||
				$model.RegistrationType === registrationTypes.types.Trust.value ||
				$model.RegistrationType === registrationTypes.types.Company.value ||
				$model.RegistrationType === registrationTypes.types.Partnership.value
			)}
				<FormRow>
					<FormColumn>
						<p>
							Please provide documents evidencing your authority to act on behalf of the claimant
						</p>
					</FormColumn>
				</FormRow>
				<FormRow>
					<FormColumn>
						{#key "dzSignedAuthorityDocs"}
						<DropZone
							{options}
							id="dzSignedAuthorityDocs"
							message="Drop files here or click to upload for this registration"
							bind:documentList={$model.signedAuthorityDocumentList}></DropZone>
						{/key}
					</FormColumn>
				</FormRow>
			{/if}

		{:else}
			<div class="form-group">
				{#if $model.documentList && $model.documentList.length > 0}
					<table class="table table-sm">
						<tr>
							<th>Document Name</th>
						</tr>
						{#each $model.documentList as file}
							<tr>
								<td>{file.fileName}</td>
							</tr>
						{/each}
					</table>
				{:else}
					<p>No documents uploaded</p>
				{/if}
			</div>

			{#if $model && (
				$model.RegistrationType === registrationTypes.types.SMSF.value ||
				$model.RegistrationType === registrationTypes.types.Trust.value ||
				$model.RegistrationType === registrationTypes.types.Company.value ||
				$model.RegistrationType === registrationTypes.types.Partnership.value
			)}
				<div class="form-group">
					{#if $model.signedAuthorityDocumentList && $model.signedAuthorityDocumentList.length > 0}
						<table class="table table-sm">
							<tr>
								<th>Written and Signed Authority Document Name</th>
							</tr>
							{#each $model.signedAuthorityDocumentList as file}
								<tr>
									<td>{file.fileName}</td>
								</tr>
							{/each}
						</table>
					{:else}
						<p>No signed authority documents uploaded</p>
					{/if}
				</div>
			{/if}
		{/if}

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons nextPageLabel="Next" />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>
